import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import type { BugReportRequest } from "../../../zodios/apiDefinitions/api/bugReport";

export function useSubmitBugReport() {
  const { t } = useTranslation(["admin"]);
  return useMutation({
    mutationFn: async (body: BugReportRequest) => {
      return await apiClient.submitBugReport(body);
    },
    onSuccess: () => {
      toast.success(t(($) => $.admin["Bug report submitted"]));
    },
    onError: () => {
      toast.error(t(($) => $.admin["Failed to submit bug report"]));
    },
  });
}
